import axios from "axios";
import { ro } from "vuetify/src/locale";

const FIND_URL = `${process.env.VUE_APP_API_URL}/model/meta/find`;
// const SAVE_URL = `${process.env.VUE_APP_API_URL}/model/meta/update`;
// const DELETE_URL = `${process.env.VUE_APP_API_URL}/model/meta/delete`;

type DataTextAttribute = {
  type: "text" | "textArea";
  valueField: string;
  label: string;
  order: string;
};

type DataOptionsAttribute = {
  type: "options";
  valueField: string;
  label: string;
  order: string;
  options: string[];
};

export interface DataItem {
  id?: string;
  attributes: {
    [key: string]: any;
  };
}

export type DataAttribute = DataTextAttribute | DataOptionsAttribute;

export interface MetadataItem {
  id: string;
  attributes: {
    collection: string;
    displayName: string;
    route: string;
    icon: string;
    order: string;
    attributes: { [key: string]: DataAttribute };
    fieldAttributes: { [key: string]: DataAttribute };
  };
}

export async function getConfiguration(routeName: string) {
  const response = await axios.post<MetadataItem[]>(FIND_URL, {
    route: routeName
  });
  return response.data[0];
}

export async function getConfigurationAsDataItems(
  routeName: string
): Promise<DataItem[]> {
  const response = await axios.post<MetadataItem[]>(FIND_URL, {
    route: routeName
  });
  const config = response.data[0];
  const id = config.id;
  const result: DataItem[] = [];

  for (const key of Object.keys(config.attributes?.attributes ?? {})) {
    const attribute = config.attributes.attributes[key];
    result.push({
      id: id + "---attributes." + key,
      attributes: {
        order: attribute.order,
        type: attribute.type,
        label: attribute.label,
        valueField: attribute.valueField
      }
    } as any);
  }
  return result;
}

export function sortedDataAttributes(dataAttributes: {
  [key: string]: DataAttribute;
}): DataAttribute[] {
  if (!dataAttributes) {
    return [];
  }
  return Object.values(dataAttributes).sort(
    (a, b) => Number.parseInt(a.order ?? "0") - Number.parseInt(b.order ?? "0")
  );
}
